import { ICeMonthlyRecord } from '~/services/api/communityEngagement/types';

type ThresholdsInEffect = Pick<
  ICeMonthlyRecord,
  'monthlyMinutesThreshold' | 'monthlyCurrencyThreshold'
>;

const hasThresholds = ({
  monthlyMinutesThreshold,
  monthlyCurrencyThreshold,
}: ThresholdsInEffect): boolean => !!monthlyMinutesThreshold || !!monthlyCurrencyThreshold;

export default hasThresholds;
